import Vue from 'vue/dist/vue'
import WIcon from '../../WIcon/WIcon.vue'

export default items => Vue.extend({
    components: {
        WIcon,
    },
    beforeCreate () {
        this.items = items
    },
    methods: {
        handleClick (action) {
            action(this.params)
        },
    },
    template: `
        <span class="ToolbarField">
            <WIcon
                v-for="({icon, action}, index) in items"
                :key="index"
                class="ToolbarFieldIcon"
                :icon="icon"
                color="primary"
                :size="18"
                @click="handleClick(action)"
            />
        </span>
    `,
})
